/* Package JSON Import will be here */
import React from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Input, Row, Col, Form, Button } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import { checkLoginIdExist } from "reducers/session";
import { INewLoginParams } from "models/sessionModels";
import { ButtonSpinner } from "components/Spinner";
/* Project Import will be here */

const UserNameForm = (props) => {
  const { translate, session, sessionOtpVerification } = useSelector((state) => ({
    translate: getTranslate(state.locale),
    session: state.session,
    wholesalers: state.wholesalers,
    sessionOtpVerification: state.sessionOtpVerification
  }));

  const dispatch = useDispatch();

  const onSubmitUserName = (values) => {
    const requestParam: INewLoginParams = {
      loginId: values.userName
    };

    dispatch(checkLoginIdExist(requestParam));
  }

  return (
    <Form
      name="newLoginUserNameForm"
      className="signIn-page"
      onFinish={onSubmitUserName}>
      <Row>
        <Col span={24} md={24} className="font-12 p-1 font-bold">
          {translate("session.signIn.userCode")}
        </Col>

        <Col span={24} md={24}>
          <Form.Item
            name="userName"
            rules={[{ required: true, message: translate("common.error.userName") }]}>
            <Input
              size="large"
              maxLength={50}
              placeholder={translate("session.signIn.placeholder.enterUnameOrMNo")}
              className="sign-in-input-height round-radius"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24} className="text-center">
          <Form.Item>
            <Button
              disabled={session.isLoading || sessionOtpVerification.isLoading}
              shape="round"
              className="sign-in-btn-width mb-1"
              type="primary"
              htmlType="submit"
            >
              {translate("common.buttons.submit")}
              {(session.isLoading || sessionOtpVerification.isLoading) && <ButtonSpinner />}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default UserNameForm;